import { render, staticRenderFns } from "./SafeHouseRequest.vue?vue&type=template&id=0dd828c6&scoped=true"
import script from "./SafeHouseRequest.vue?vue&type=script&lang=ts"
export * from "./SafeHouseRequest.vue?vue&type=script&lang=ts"
import style0 from "./SafeHouseRequest.vue?vue&type=style&index=0&id=0dd828c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd828c6",
  null
  
)

export default component.exports